(function () {
  function initStaticSlider(wrapper) {
    const slides = Array.from(wrapper.querySelectorAll('[data-static-slider-slide]'));
    if (slides.length === 0) return;

    const thumbnails = Array.from(wrapper.querySelectorAll('[data-static-slider-thumbnail]'));
    const dots = Array.from(wrapper.querySelectorAll('[data-static-slider-dot]'));
    const headingEl = wrapper.querySelector('[data-static-slider-heading]');
    const subheadingEl = wrapper.querySelector('[data-static-slider-subheading]');
    const prevButton = wrapper.querySelector('[data-static-slider-prev]');
    const nextButton = wrapper.querySelector('[data-static-slider-next]');
    const desktopNextButton = wrapper.querySelector('[data-static-slider-desktop-next]');

    let currentIndex = 0;
    let isTransitioning = false;

    function getSlideText(slide, attribute, fallback) {
      const value = slide.getAttribute(attribute);
      return value && value.length > 0 ? value : fallback;
    }

    function updateText(index) {
      const slide = slides[index];
      if (!slide) return;

      const defaultHeading = wrapper.getAttribute('data-default-heading') || '';
      const defaultSubheading = wrapper.getAttribute('data-default-subheading') || '';
      const headingText = getSlideText(slide, 'data-heading', defaultHeading);
      const subheadingText = getSlideText(slide, 'data-subheading', defaultSubheading);

      if (headingEl) {
        headingEl.textContent = headingText;
      }

      if (subheadingEl) {
        subheadingEl.textContent = subheadingText;
        subheadingEl.hidden = subheadingText.length === 0;
      }
    }

    function setActiveControls(index) {
      thumbnails.forEach((thumbnail, thumbIndex) => {
        thumbnail.classList.toggle('is-active', thumbIndex === index);
        thumbnail.setAttribute('aria-current', thumbIndex === index ? 'true' : 'false');
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function goToSlide(index) {
      if (isTransitioning || index === currentIndex || index < 0 || index >= slides.length) {
        return;
      }

      isTransitioning = true;

      const currentSlide = slides[currentIndex];
      const nextSlide = slides[index];

      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      currentIndex = index;
      updateText(index);
      setActiveControls(index);

      window.setTimeout(function () {
        isTransitioning = false;
      }, 300);
    }

    function goToPrev() {
      const nextIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
      goToSlide(nextIndex);
    }

    function goToNext() {
      const nextIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
      goToSlide(nextIndex);
    }

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        const index = parseInt(thumbnail.getAttribute('data-slide-index'), 10);
        goToSlide(index);
      });
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const index = parseInt(dot.getAttribute('data-slide-index'), 10);
        goToSlide(index);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', goToPrev);
    }

    if (nextButton) {
      nextButton.addEventListener('click', goToNext);
    }

    if (desktopNextButton) {
      desktopNextButton.addEventListener('click', goToNext);
    }

    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPrev();
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToNext();
      }
    });

    updateText(0);
    setActiveControls(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.static-slider-wrapper').forEach(initStaticSlider);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const wrapper = event.target.querySelector('.static-slider-wrapper');
    if (wrapper) initStaticSlider(wrapper);
  });
})();
